<template>
  <div class="--btn-feedback" :class="{ 'pointer-events-none': disabled, '--bfb-sm': size === 'small' }">
    <div
      v-if="multiple && isLeft"
      class="inline-flex w-10 shrink-0 items-center justify-center self-stretch bg-slate-500/80 text-center text-base font-normal text-white"
    >
      {{ modelValue?.length }}
    </div>
    <slot>
      <div class="--bfb-content grow truncate">
        <span :class="{ 'italic text-neutral-500 dark:text-neutral-200': !label && placeholder }">{{
          label || placeholder || '‎'
        }}</span>
      </div>
    </slot>
    <div v-if="clearable && modelValue" class="--bfb-icon" @click.stop="removeSelected">
      <UiIcon :size="size === 'small' ? 18 : 24" class="hover:text-red-500" icon="trash" />
    </div>
    <div class="--bfb-icon" v-if="!disabled">
      <UiIcon :size="size === 'small' ? 18 : 24" icon="search" />
    </div>
    <div
      v-if="multiple && !isLeft"
      class="inline-flex w-10 shrink-0 items-center justify-center self-stretch bg-slate-500/80 text-center text-base font-normal text-white"
    >
      {{ modelValue?.length }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { dialog } from '@/common/util'
import { computed } from 'vue'
import UiIcon from '@/components/ui/icon.vue'

const emit = defineEmits(['onRemoveSelected', 'update:modelValue'])

const props = defineProps<{
  modelValue?: any
  position?: string
  multiple?: boolean
  placeholder?: string
  data?: any
  propName?: string
  disabled?: boolean
  clearable?: boolean
  size?: string
}>()
const isLeft = computed(() => !props.position || props.position !== 'right')

const label = computed(() => {
  if (props.data && props.modelValue) {
    const valueFound = props.data?.find((el) => el.id === props.modelValue)
    return props?.propName ? valueFound?.[props.propName] : valueFound?.nome
  }

  return ''
})

const removeSelected = () => {
  if (props.disabled) return

  dialog.open({
    title: 'Atenção!',
    message: `Deseja realmente remover o registro selecionado?`,
    complete: () => emit('update:modelValue', '')
  })
}
</script>

<style lang="scss" scoped>
.--btn-feedback {
  @apply flex items-center overflow-hidden rounded-lg border border-solid border-black 
  hover:cursor-pointer hover:bg-neutral-200 dark:border-neutral-600 dark:hover:bg-neutral-600;

  .--bfb-content {
    @apply px-4 py-[14px] text-base font-normal leading-4;
  }
  .--bfb-icon {
    @apply cursor-pointer p-2;
  }

  &.--bfb-sm {
    @apply border border-black/20;

    .--bfb-content {
      @apply px-1 py-0  text-sm leading-3;
    }
    .--bfb-icon {
      @apply p-1;
    }
  }
}

.error .--btn-feedback {
  @apply border-red-500;
}
</style>
